import { WORDS } from '../constants/wordlist'
import { VALIDGUESSES } from '../constants/validGuesses'

export const isWordInWordList = (word: string) => {
  return (
    WORDS.includes(word.toLowerCase()) ||
    VALIDGUESSES.includes(word.toLowerCase())
  )
}

export const isWinningWord = (word: string) => {
  return solution === word
}

export const getWordOfDay = () => {
  // January 1, 2022 Game Epoch
  const msInDay = 86400000  
  const msInHour = 3600000

  const dstOffset = new Date('January 1, 2022 00:00:00').getTimezoneOffset()/60 - (new Date()).getTimezoneOffset()/60

  const epochMs = new Date('January 1, 2022 00:00:00').valueOf()

  const now = Date.now() + (msInHour * dstOffset) 
  

  const index = Math.floor((now - epochMs) / msInDay)
  
  const nextDay = (index + 1) * msInDay + epochMs - (msInHour * dstOffset) 

  return {
    solution: WORDS[index % WORDS.length].toUpperCase(),
    solutionIndex: index,
    tomorrow: nextDay,
  }
}

export const { solution, solutionIndex, tomorrow } = getWordOfDay()
